import { values as lodashValues, sortBy } from 'lodash';

import { type Account, getAccountDisplayName } from './model';

type NormalizedResponse = {
  entities?: {
    accounts?: Record<string, Account>;
  };
  result?: {
    items?: string[];
  };
};

export function extractAccounts(data: NormalizedResponse | undefined): Account[] {
  const entities = data?.entities?.accounts as Record<string, Account> | undefined;
  if (!entities) {
    return [];
  }
  const list = lodashValues(entities) as Account[];
  return sortBy(list, (account) => getAccountDisplayName(account).toLowerCase());
}

// Mirrors legacy getAccountSearch mapping: resolve ordered ids to entity array
export function extractAccountsByIds(data: NormalizedResponse | undefined): Account[] {
  const entities = data?.entities?.accounts as Record<string, Account> | undefined;
  const ids: string[] = (data?.result?.items as string[]) || [];
  if (!entities || !Array.isArray(ids) || ids.length === 0) {
    return [];
  }
  return ids.map((id) => entities[id]).filter(Boolean) as Account[];
}
